import { apiClient } from '@/core/api/client';
import type {
  FinancialAdvisorProfile,
  UpdateFinancialAdvisorProfilePayload,
} from '../types/financial-advisor-profile.types';

export const financialAdvisorProfileApi = {
  getProfile: async (advisorId: string): Promise<FinancialAdvisorProfile> => {
    const response = await apiClient.get<FinancialAdvisorProfile>(
      `/financial-advisors/${advisorId}/profile`,
    );
    return response.data;
  },

  getMyProfile: async (): Promise<FinancialAdvisorProfile> => {
    const response = await apiClient.get<FinancialAdvisorProfile>('/financial-advisors/me/profile');
    return response.data;
  },

  updateProfile: async (
    advisorId: string,
    payload: UpdateFinancialAdvisorProfilePayload,
  ): Promise<FinancialAdvisorProfile> => {
    const response = await apiClient.patch<FinancialAdvisorProfile>(
      `/financial-advisors/${advisorId}/profile`,
      payload,
    );
    return response.data;
  },

  updateMyProfile: async (
    payload: UpdateFinancialAdvisorProfilePayload,
  ): Promise<FinancialAdvisorProfile> => {
    const response = await apiClient.patch<FinancialAdvisorProfile>(
      '/financial-advisors/me/profile',
      payload,
    );
    return response.data;
  },
};
